function handleFirstTab(e) {
  if (e.keyCode === 9) { // tab
      document.body.classList.add('user-is-tabbing');
  }
}
window.addEventListener('keydown', handleFirstTab);
document.addEventListener("click", function(){
document.body.classList.remove('user-is-tabbing');
});

function throttle(callback, delay) {
  let timer;
  return (...args) => {
    if (timer) {
      return;
    }

    timer = setTimeout(() => {
      callback(...args);
      timer = null;
    }, delay);
  };
} 

$(function() {

  /* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  var oSlideToggle = jQuery.fn.slideToggle;
  jQuery.fn.slideToggle = function() {
    if(Simplistic.reducedMotion()){
       return jQuery.fn.toggle.apply(this, arguments);
    }else{
      return oSlideToggle.apply(this, arguments);
    }
  };
  var oSlideDown = jQuery.fn.slideDown;
  jQuery.fn.slideDown = function() {
    if(Simplistic.reducedMotion()){
       return jQuery.fn.show.apply(this, arguments);
    }else{
      return oSlideDown.apply(this, arguments);
    }
  };
  var oSlideUp = jQuery.fn.slideUp;
  jQuery.fn.slideUp = function() {
    if(Simplistic.reducedMotion()){
       return jQuery.fn.hide.apply(this, arguments);
    }else{
      return oSlideUp.apply(this, arguments);
    }
  };
  /* End of Reduced Motion */

  jQuery.fn.sortDomElements = (function() {
      return function(comparator) {
          return Array.prototype.sort.call(this, comparator).each(function(i) {
                this.parentNode.appendChild(this);
          });
      };
  })();

  if(!isMobile.any) {
    $('body').addClass('isNotMobile');
  }

  $(document).on("click", ".quantity-box .minus", function(e) {
      e.preventDefault();
      var input = $(this).parent().find('input[type=number]');
    try {
        if(input.attr('min')<input.val()) {
          input.get(0).stepDown();
          input.change();
        }
      } catch(e) {
        var value = (parseInt(input.val())-1);
        input.val((value>=0 ? value : 0));
        input.change();
      }
  });
  $(document).on("click", ".quantity-box .plus", function(e) {
      e.preventDefault();
      var input = $(this).parent().find('input[type=number]');
    try {
        input.get(0).stepUp();
        input.change();
      } catch(e) {
        var value = (parseInt(input.val())+1);
        input.val(value);
        input.change();
      }
  });

  /********* QUICK VIEW *********/
  $(document).on('click', '.product-item .quick-view-btn', function(){
    var url = $(this).data('url');
    $('#loading-overlay').show();

    $.ajax({
      url: url,
      cache: false
    }).success(function(data){
      $('#loading-overlay').hide();
    });

    return false;
  });

  initSideCart();$('body').delegate('.add-to-cart-form', 'submit', function(){
        if(validateAddCart($(this))) {
          addToCart($(this));
        }
        return false;
    });

    $('body').delegate('.add-to-cart-bundle-form', 'submit', function(){
        if(validateAddCart($(this))) {
          addToCartBundle($(this));
        }
        return false;
    });// Cache DOM references for better performance
  var header = $('#header');
  var $scrollup = $('.scrollup');
  var $headerDrop = $('.header-drop');
  var $body = $('body');
  
  // Cache window dimensions and header height
  var prevWindowWidth = window.innerWidth;
  var cachedHeaderHeight = header[0] ? header[0].offsetHeight : 80;
  var cachedWindowHeight = window.innerHeight;
  
  var previousScrollPosition = null;
  var scrollDirection = null;
  var rafId = null;

  // Debounced resize handler to update cached dimensions
  const resizeHandler = throttle(() => {
    prevWindowWidth = window.innerWidth;
    cachedWindowHeight = window.innerHeight;
    // Safely update header height with null checks
    if (header && header[0]) {
      cachedHeaderHeight = header[0].offsetHeight;
    } else {
      cachedHeaderHeight = 80; // fallback
    }
  }, 250);

  const scrollEventHandler = (event) => {
    // Cancel previous animation frame
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    
    rafId = requestAnimationFrame(() => {
      // Skip if window is resizing
      if (window.innerWidth !== prevWindowWidth) { 
        return;
      }

      var scrollTop = $(window).scrollTop();
    
      if ((previousScrollPosition||0) < scrollTop) {
        scrollDirection = 'down';
      } else if ((previousScrollPosition||0) > scrollTop) {
        scrollDirection = 'up';
      }
      
      // Update scrollup button visibility
      if(scrollTop <= 200) {
        $scrollup.removeClass('fadein');
      } else {
        $scrollup.addClass('fadein');
      }// Check if current page is PLP or SRP
        const isPLPorSRP = window.location.pathname.includes('/collections/') || window.location.pathname.includes('/search');
        
        if (!isPLPorSRP) {
          // Use cached window height for better performance
          let buffer = Math.max(cachedWindowHeight * 0.77, 666);
          if(scrollDirection == 'up' && scrollTop >= buffer + Math.max(80, cachedHeaderHeight) ) {
            $headerDrop.addClass('scroll');
          } else {
            $headerDrop.removeClass('scroll');
          }
        }// Update body scroll class using cached header height
      if( scrollTop >= Math.max(80, cachedHeaderHeight) ) {
        $body.addClass('scroll');
      } else {
        $body.removeClass('scroll');
      }
      previousScrollPosition = scrollTop;
    });
  }

  /* scroll event with passive listener for better performance */ 
  window.addEventListener('scroll', scrollEventHandler, { passive: true });
  
  /* resize event handler */
  window.addEventListener('resize', resizeHandler); 

  $('.header-drop .main-menu').html($('#header .main-menu').html());     
  $('.header-drop .main-menu a').attr({'focusable':'false','tabindex':'-1','aria-hidden':'true'});
  
    setupDropdownMenus('.main-menu');
    setupDropdownMenus('.bar_menu');

    $(document).on('click', '.scrollTo', function(){
      $.scrollTo($(this).attr('href'), 1000, {offset: - Math.max(80, header[0].offsetHeight) -30});
      return false;
    });
});

function setupDropdownMenus(target_menu){
function syncDesktopMegaNavState() {
  $('body').toggleClass(
    'desktop-mega-nav-open',
    $('.main-menu .has-dropdown.menu-open, .bar_menu .has-dropdown.menu-open').length > 0
  );
}

var config = {
  over: function () {
    $(this).addClass('menu-open').find('.submenu:first').slideDown();
    syncDesktopMegaNavState();
  },
  timeout: 400,
  out: function () {
    $(this).removeClass('menu-open').find('.submenu:first').slideUp();
    syncDesktopMegaNavState();
  }
};
$(` ${target_menu} .has-dropdown `).hoverIntent(config); 

  $(document).on('keydown', ` ${target_menu} .has-dropdown a:focus`, function(e){
    if (e.which == 32) { //Spacebar
      e.preventDefault();
      $(this).parent('.has-dropdown').toggleClass('menu-open');
      $(this).next().slideToggle();
      syncDesktopMegaNavState();
    }
    if (e.which == 40) { //Arrow Down
      e.preventDefault();
      $(this).parent('.has-dropdown').addClass('menu-open');
      $(this).next().slideDown();
      syncDesktopMegaNavState();
    }
    if (e.which == 38) { //Arrow Up
      e.preventDefault();
      $(this).parent('.has-dropdown').removeClass('menu-open');
      $(this).next().slideUp();
      syncDesktopMegaNavState();
    }
  });
  $(document).on('keydown', `${target_menu} .has-dropdown .has-dropdown a:focus`, function(e){
    if (e.which == 39) { //Arrow Right
      e.preventDefault();
      $(this).parent('.has-dropdown').addClass('menu-open');
      $(this).next().slideDown();
      syncDesktopMegaNavState();
    }
    if (e.which == 37) { //Arrow Left
      e.preventDefault();
      $(this).parent('.has-dropdown').removeClass('menu-open');
      $(this).next().slideUp();
      syncDesktopMegaNavState();
    }
  });
}

function validateAddCart(form) {
if(form.find('input[name=id]').val()=='') {
      var allOptionsSelected;
      if(form.find('.single-option-selector').length > 0) {
          allOptionsSelected = true;
          form.find('.single-option-selector').each(function(){
              if($(this).val()=="") {
                  allOptionsSelected = false;
                  return false;
              }
          });
      } else {
          allOptionsSelected = false;
      }

      if(allOptionsSelected) {
          var errorMsg = form.find('.validation-msg').text();
          if(errorMsg) {
            alert(errorMsg);
          } else {
            alert("The selected variant is sold out.");
          }
      } else {
        var labels = [];
          form.find('.options label').each(function(key, obj){
              labels.push($(obj).text().replace(':', '').trim());
          });
          alert("You must select a "+labels.join('/')+".");
      }
      return false;
  }
  return true;
}

function initSideCart() {
  $('body').delegate('.cart-wrap, a[href="/cart"], a[href="/cart/"]', 'click', function(e){
    e.stopPropagation();
    if(window.GreenPanUseRebuySmartCart && window.GreenPanSideCart && typeof window.GreenPanSideCart.open === 'function') {
      window.GreenPanSideCart.open();
    } else {
      showSideCart(true);
    }
    return false;
  });

  $('body').delegate('[data-side-cart-close]', 'click', function(e){
    e.preventDefault();
    e.stopPropagation();
    hideSideCart();
    return false;
  });

  $(document).click(function(event){
    if(!$(event.target).closest('#side-cart .side-cart__panel, .cart-wrap').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
      hideSideCart();
    }
  });

  $(document).on('keydown.sideCart', function(e){
    if(e.which == 27 && $('#side-cart').hasClass('open')) {
      e.preventDefault();
      hideSideCart();
      return false;
    }
  });

  if(/[?&]viewcart=true(?:&|$)/.test(window.location.search)) {
    setTimeout(function(){
      if(window.GreenPanUseRebuySmartCart && window.GreenPanSideCart && typeof window.GreenPanSideCart.open === 'function') {
        window.GreenPanSideCart.open();
      } else {
        showSideCart(true);
      }
    }, 250);
  }
}

function addToCart(form, callback){
$('#loading-overlay').show();
  var productJs = form.closest('.initialized').data('productjs');
  if(productJs) {
    $(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
  } else {
    $(document).trigger("addToCart", [form]);
  }

$.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: function(){
      if(productJs) {
        $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
      } else {
        $(document).trigger("addToCartSuccess", [form]);
      }
      if(callback) {
        callback();
      } else {
        addToCartSuccess();
      }
      customEvents.addToCart();
    },
    cache: false
});
}

function addToCartBundle(form, callback){
  $('#loading-overlay').show();
  var productJs = form.closest('.initialized').data('productjs');
  if(productJs) {
    $(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
  } else {
    $(document).trigger("addToCart", [form]);
  }

  const newForm = form[0];
  const bundleInfo = newForm.querySelector('#bundle-json')
  var bundleDataJSON =  JSON.parse(bundleInfo.innerHTML)
  var products = bundleDataJSON.products
  var bundle_title = bundleDataJSON.bundle_title
  var bundleId = 'bundle-' + bundleDataJSON.bundle_id
  var bundleVariantId = bundleDataJSON.bundle_variant_id
  var bundle_parent_id = bundleDataJSON.bundle_id
  var formQuantity = newForm.querySelector('[data-quantity]')?.value || 1
  var itemsArray = []

  for (var i = 0; i < products.length; i++) {
    var product = products[i]
    var item = {
      id: product.variant_id,
      quantity: formQuantity ,
      properties: {
        _bundleID: bundleId,
        _bundleTitle: bundle_title,
        _bundleParent: false,
        _bundleChild: true,
        _bundleParentVariantID: bundleVariantId,
        _bundleParentID: bundle_parent_id,
        _bundleProductAvailability: product.product_available
      }
    }
    if (product.product_available) {
      itemsArray.push(item)
    }
  }

  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {items: itemsArray},
      dataType: 'json',
      error: addToCartFail,
      success: function(){
        if(productJs) {
          $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
        } else {
          $(document).trigger("addToCartSuccess", [form]);
        }
        if(callback) {
          callback();
        } else {
          addToCartSuccess();
        }
        customEvents.addToCart();
      },
      cache: false
  });
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
  if(window.GreenPanUseRebuySmartCart && window.GreenPanSideCart && typeof GreenPanSideCart.open === 'function') {
    $('#loading-overlay').hide();
    if(GreenPanSideCart.open() !== false) {
      return;
    }
  }

  updateCartDesc(true);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('#loading-overlay').hide();
}

function updateCartDesc(openSideCart){
  if(window.GreenPanUseRebuySmartCart) {
    $('#loading-overlay').hide();
    if(openSideCart && window.GreenPanSideCart && typeof window.GreenPanSideCart.open === 'function') {
      window.GreenPanSideCart.open();
    }
    return;
  }

  $.ajax({
  type: 'GET',
  url: '/cart?view=side-cart',
  cache: false,
      success: function(data){
        $('#loading-overlay').hide();
        var animate = true;
        if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
          animate = false;
        }
        $('#side-cart').remove();
        $('#page').append(data);
        if(openSideCart){
          if($('#side-cart').length) {
            showSideCart(animate);
          } else {
            window.location.href = '/cart';
          }
        }
      },
      error: function(){
        $('#loading-overlay').hide();
        if(openSideCart) {
          window.location.href = '/cart';
        }
      }
});
}

function showSideCart(animate) {
  if(window.GreenPanUseRebuySmartCart && window.GreenPanSideCart && typeof window.GreenPanSideCart.open === 'function') {
    window.GreenPanSideCart.open();
    return;
  }

  var $sideCart = $('#side-cart');

  if(!$sideCart.length) {
    updateCartDesc(true);
    return;
  }

  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  $sideCart.attr('aria-hidden', 'false').addClass('is-visible');

  if(animate) {
    setTimeout(function(){$sideCart.addClass('open')}, 50);
  } else {
    $sideCart.removeClass('ease-animation-slow');
    $sideCart.addClass('open');
    setTimeout(function(){$sideCart.addClass('ease-animation-slow')}, 200);
  }

  if(window.Simplistic && typeof Simplistic.trapFocus === 'function') {
    Simplistic.trapFocus({
      $container: $sideCart,
      namespace: 'side-cart'
    });
  }
}

function hideSideCart() {
$('#side-cart').removeClass('open is-visible').attr('aria-hidden', 'true');
$('#page').removeClass('mode-overlay');
$('body, html').css({overflow: ''});
if(window.Simplistic && typeof Simplistic.removeTrapFocus === 'function') {
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'),
    namespace: 'side-cart'
  });
}
}

window.SimplisticJS = function (){
this.formatMoney = window.themeMoneyFormat || null;
this.beforeTrapFocus = false;

/**
 * Traps the focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
 * @param {string} options.namespace - Namespace used for new focus event handler
 */
this.trapFocus = function(options) {
  this.beforeTrapFocus = $(':focus');
  var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

  if (!options.$elementToFocus) {
    options.$elementToFocus = options.$container;
  }

  options.$container.attr('tabindex', '-1');
  options.$elementToFocus.focus();

  $(document).on(eventName, function(evt) {
    if (
      options.$container[0] !== evt.target &&
      !options.$container.has(evt.target).length
    ) {
      options.$container.focus();
    }
  });
},

/**
 * Removes the trap of focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {string} options.namespace - Namespace used for new focus event handler
 */
this.removeTrapFocus = function(options) {
  var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

  if (options.$container && options.$container.length) {
    options.$container.removeAttr('tabindex');
  }
  if(this.beforeTrapFocus) {
    this.beforeTrapFocus.focus();
      this.beforeTrapFocus = false;
  }

  $(document).off(eventName);
}

this.handleize = function (str) {
  //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
  return str.toLowerCase().replace(/\'|\"/g, "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

this.reducedMotion = function() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

this.getQueryParam = function(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

this.randomstring = function(L){
  var s= '';
  var randomchar=function(){
    var n= Math.floor(Math.random()*62);
    if(n<10) return n; //1-10
    if(n<36) return String.fromCharCode(n+55); //A-Z
    return String.fromCharCode(n+61); //a-z
  }
  while(s.length< L) s+= randomchar();
  return s;
}

this.validateEmail = function(email) {
  var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return re.test(email);
}

this.onImagesLoaded = function(images, callback){
  var imagesLoaded = 0;
  var loadFunction = function() {
    imagesLoaded++;
    if(imagesLoaded==images.length) {
      callback();
    }
  };
  if(images.length>0) {
    images.each(function(){
      var img = new Image();
      img.onload = loadFunction;
      img.onerror = loadFunction;
      img.src = $(this).attr('src');
    });
  } else {
    callback();
  }
};

this.Media = new function() {
  var media = this;
  var mqS = window.matchMedia("(max-width: 600px)");
  var mqM = window.matchMedia("(max-width: 900px)");
  var mqO = window.matchMedia("(orientation: landscape)");
  var tId = 0;
  function updateMedia() {
    media.isLarge = !mqM.matches;
    media.isMediumUp = !mqS.matches;
    media.isMedium = mqM.matches && !mqS.matches;
    media.isMediumDown = mqM.matches;
    media.isSmall = mqS.matches;
    media.isLandscape = mqO.matches;
  }
  function handler() {
    clearTimeout(tId);
    tId = setTimeout(function() {
      updateMedia();
      $(window).trigger('mediaChange');
    }, 1);
  }
  updateMedia();
  mqS.addListener(handler);
  mqM.addListener(handler);
  mqO.addListener(handler);
  return this;
}

this.matchHeight = function (elements) {
  var height = 0;
  elements.each(function(ix, e) {
    $(e).css('min-height', '');
  });
  elements.each(function(ix, e) {
    height = Math.max(height, $(e).outerHeight());
  });
  elements.each(function(ix, e) {
    $(e).css('min-height', height);
  });
}

this.YoutubePlayer = new function() {
  var apiLoaded = null;
  window.onYouTubeIframeAPIReady = function() {
    apiLoaded.resolve();
  }
  this.extractVideoID = function(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    if ( match && match[7]){
      return match[7];
    }else{
      console.error("Could not extract video ID.");
    }
  }
  function init() {
    if (!apiLoaded)
      apiLoaded = $.Deferred();
    var apiUrl = 'https://www.youtube.com/iframe_api';
    if (!document.querySelector('script[src="'+apiUrl+'"]')) {
      var tag = document.createElement('script');
      tag.src = apiUrl;
      tag.defer = true
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
  this.loadVideo = function(fn) {
    init();
    apiLoaded.done(fn);
  }
}
};
window.Simplistic = new SimplisticJS();
